import { useCallback } from "preact/hooks";
import { useSignal } from "@preact/signals";

const useForceRender = () => {
    const state = useSignal(0);

    const update = useCallback(() => {
        state.value = state.value + 1;
    }, [state]);

    void state.value;

    return update;
};

export default useForceRender;
